import { Component, Input, OnInit } from '@angular/core';
import { RevenueItemService } from 'src/app/revenue/shared/revenue-items/revenue-item.service';
import { ProfileMetadataLego } from '../../shared/dto/profile-metadata.lego';
import { EmailOptInMetaDataLego } from '../../shared/dto/email-optin-metadata.lego';

@Component({
  selector: 'wl-profile-lego-summary',
  templateUrl: './profile-lego-summary.component.html',
  styleUrls: ['./profile-lego-summary.component.less'],
    standalone: false
})
export class ProfileLegoSummaryComponent implements OnInit {
  @Input() profileData: ProfileMetadataLego;

  constructor() {}

  ngOnInit(): void {}
}
